<script>
  let { size = "md", color = "indigo" } = $props();

  // Compute size classes
  $effect(() => {
    switch (size) {
      case "sm":
        sizeClass = "h-8 w-8";
        textClass = "text-lg";
        break;
      case "lg":
        sizeClass = "h-16 w-16";
        textClass = "text-3xl";
        break;
      default: // md
        sizeClass = "h-12 w-12";
        textClass = "text-2xl";
    }
  });

  // Compute color classes
  $effect(() => {
    switch (color) {
      case "purple":
        colorClass = "text-purple-600 bg-purple-100";
        textColorClass = "text-purple-600";
        break;
      case "gray":
        colorClass = "text-gray-600 bg-gray-100";
        textColorClass = "text-gray-600";
        break;
      default: // indigo
        colorClass = "text-indigo-600 bg-indigo-100";
        textColorClass = "text-indigo-600";
    }
  });

  let sizeClass = $state("h-12 w-12");
  let textClass = $state("text-2xl");
  let colorClass = $state("text-indigo-600 bg-indigo-100");
  let textColorClass = $state("text-indigo-600");
</script>

<div class="flex flex-col items-center">
  <div
    class={`${sizeClass} ${colorClass} rounded-full flex items-center justify-center`}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="w-2/3 h-2/3"
    >
      <!-- Chart line representing tracking -->
      <polyline points="4,14 8,10 12,12 16,6 20,8" />
      <!-- Social media icons representation -->
      <circle cx="4" cy="14" r="1.5" fill="currentColor" />
      <circle cx="8" cy="10" r="1.5" fill="currentColor" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      <circle cx="16" cy="6" r="1.5" fill="currentColor" />
      <circle cx="20" cy="8" r="1.5" fill="currentColor" />
    </svg>
  </div>
</div>
